import { Height } from "@mui/icons-material";


import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';


export default  function welcomePage(){
    return  (<div><div style={{display:'flex',justifyContent:'center'}}>
        <img  src="/images/login/Dashboard/Assert/Welcomeimage.webp" alt="First slide" style={{height:"400px",display:'flex',justifyContent:'center'}}/>
        
        </div>
        <div style={{marginTop:'50px'}}>
        <Link style={{width:'100%',backgroundColor:'yellow',borderRadius:'5px',display:'block',padding:'10px',textAlign:'center',fontSize:'larger',cursor:'pointer', textDecoration: 'none', }} component={Link} to="/package">Book Your Ride</Link></div>
        </div>);
}